<script setup>
import { Head, useForm } from '@inertiajs/inertia-vue3';
import MainLayout from '../../Layouts/MainLayout';
import useRotas from '../../Composables/useRotas';
import {ref} from "vue";

const route = useRotas();

const form = useForm({
    nome: null,
    email: null,
    telefone: null,
    empresa: null,
})

const emailContato = ref(window.doulheTresConfig.email_contato);
const telefoneContato = ref(window.doulheTresConfig.telefone_contato);

</script>

<template>
    <Head title="Quero Vender"/>
    <MainLayout>
        <q-page>
            <div
                class="flex q-mx-sm column wrap items-center"
            >
                <div
                    class="flex q-pt-lg row"
                >
                    <div
                        class="text-primary q-pa-none full-width"
                    >
                        <h1 class="
                                text-center text-primary text-h4 text-bold full-width
                                q-my-md
                            ">
                            Quero Vender
                        </h1>
                        <h2 class="
                                text-center text-h5 full-width
                                q-my-md
                            "
                            style="color: rgb(194, 0, 11);"
                        >
                            Transforme seus bens em liquidez
                        </h2>
                        <p class="text-center text-italic q-px-md">
                            Imóveis, veículos, máquinas e outros bens vendidos de forma rápida, segura e transparente. Transforme seus ativos em liquidez!
                        </p>
                    </div>
                </div>
                <div
                    :class="$q.screen.lt.sm ? '' : 'q-px-xl'"
                    class="q-pt-md col-12 row items-start "
                >
                    <div class="col col-12 col-md-6 col-sm-12  q-px-md">
                        <h6 class="
                                text-center text-primary text-h6 full-width
                                q-my-md titulo-borda
                            ">
                            Já pensou em vender seus bens em leilão?
                        </h6>
                        <p>
                            Com a <b>Montenegro Leilões</b>, você conta com mais de 40 anos de experiência, uma das maiores estruturas do Norte e Nordeste e uma equipe especializada e dedicada em cada etapa. Colocamos seu ativo diante de milhares de compradores qualificados, com toda a segurança jurídica e a agilidade que o leilão proporciona.
                        </p>
                        <p class="text-bold titulo-borda">
                            Por que vender com a Montenegro?
                        </p>
                        <ul class="lista-bolinha">
                            <li><b>Alcance ampliado —</b> seu bem exposto a milhares de compradores em nossas plataformas online.</li>
                            <li><b>Rapidez na venda —</b> o leilão define data e horário de encerramento, transformando seu ativo em liquidez com prazo definido.</li>
                            <li><b>Gestão sem burocracia —</b> cuidamos de tudo, da avaliação do bem até a entrega final. Você foca no seu negócio, e nós cuidamos da operação.</li>
                            <li><b>Segurança e transparência —</b> leilões conduzidos por leiloeiros oficiais matriculados na JUCEC, com total lisura em cada lance.</li>
                            <li><b>Divulgação inteligente —</b> usamos bases de compradores segmentadas e campanhas direcionadas para cada tipo de item.</li>
                            <li><b>Suporte completo —</b> acompanhamos do primeiro contato à finalização, cuidando de toda a operação.</li>
                        </ul>
                        <p class="text-bold titulo-borda">
                            Como funciona, passo a passo
                        </p>
                        <ol class="lista-passos">
                            <li><b>Fale com a gente —</b> preencha o formulário ou entre em contato pelos nossos canais informando o bem que deseja vender.</li>
                            <li><b>Avaliação —</b> nossa equipe analisa o bem, orienta sobre a documentação e define a melhor estratégia.</li>
                            <li><b>Preparação do lote —</b> cuidamos da divulgação, das fotos e da publicação do leilão em nossas plataformas.</li>
                            <li><b>Realização do leilão —</b> acompanhamos todo o pregão em tempo real, com suporte durante a disputa de lances.</li>
                            <li><b>Fechamento e pagamento —</b> conduzimos os trâmites com o arrematante e damos todo o suporte pós-leilão até a finalização.</li>
                        </ol>
                        <p class="text-bold titulo-borda">
                            O que você pode vender
                        </p>
                        <p>
                            Trabalhamos com uma ampla variedade de bens. Entre os mais comuns:
                        </p>
                        <ul class="lista-bolinha">
                            <li>Imóveis residenciais, comerciais, rurais e terrenos</li>
                            <li>Veículos leves, pesados, motocicletas e frotas</li>
                            <li>Máquinas e equipamentos industriais e agrícolas</li>
                            <li>Bens diversos e outros ativos</li>
                        </ul>
                    </div>

                    <div class="flex column col col-12 col-md-6 col-sm-12 q-px-md">
                        <h6 class="
                                text-center text-primary text-h6 full-width
                                q-my-md titulo-borda
                            ">
                            Preencha o formulário e entraremos em contato
                        </h6>
                        <p>
                            Conte para a nossa equipe qual bem você deseja vender. Retornaremos o contato para orientar você sobre os próximos passos. Campos com * são obrigatórios.
                        </p>
                        <q-form
                            @submit="form.post(route('institucional.queroVender.enviar'))"
                            class="full-width q-px-md"
                        >
                            <q-input
                                v-model="form.nome"
                                class="q-mb-sm"
                                filled
                                label="Nome completo"
                                hint="Seu nome"
                                lazy-rules
                                :rules="[ val => val && val.length > 0 || 'Por favor, digite um nome']"
                            >
                                <template v-slot:append>
                                    <q-icon color="red" size="15px" name="mdi-asterisk"/>
                                </template>
                            </q-input>
                            <q-input
                                v-model="form.email"
                                class="q-mb-sm"
                                filled
                                type="email"
                                label="E-mail"
                                hint="Digite seu e-mail"
                                unmasked-value
                                lazy-rules
                                :rules="[
                                        val => val && val.length > 0 || 'Por favor, digite um email',
                                   ]"
                            >
                                <template v-slot:append>
                                    <q-icon color="red" size="15px" name="mdi-asterisk"/>
                                </template>
                            </q-input>
                            <q-input
                                filled
                                class="q-mb-sm"
                                v-model="form.telefone"
                                mask="(##) #####-####"
                                hint="DDD + número: (00) 00000-0000"
                                label="Telefone"
                                unmasked-value
                                lazy-rules
                                :rules="[
                                        val => val && val.length > 0 || 'Por favor, digite um telefone',
                                    ]"
                            >
                                <template v-slot:append>
                                    <q-icon color="red" size="15px" name="mdi-asterisk"/>
                                </template>
                            </q-input>
                            <q-input
                                filled
                                class="q-pb-none"
                                v-model="form.empresa"
                                label="Empresa"
                                hint="Nome da sua empresa (se houver)"
                                unmasked-value
                                lazy-rules
                                :rules="[
                                        val => val && val.length > 0 || 'Por favor, digite o nome da empresa comitente',
                                   ]"
                            >
                                <template v-slot:append>
                                    <q-icon color="red" size="15px" name="mdi-asterisk"/>
                                </template>
                            </q-input>
                            <div class="flex row justify-around q-mt-lg">
                                <q-btn style="flex:3.5;" type="submit" color="primary">
                                    Enviar
                                </q-btn>
                                <q-btn
                                    class="q-ml-sm"
                                    @click="form.reset()"
                                    style="flex: 1.5;"
                                    label="Limpar" type="reset"
                                    text-color="primary"
                                />
                            </div>
                        </q-form>
                        <div class="full-width q-mt-lg">
                            <p class="text-center text-bold">
                                Prefere falar direto com a gente?
                            </p>
                            <p class="text-center">
                                {{ emailContato }}&nbsp;&nbsp;&nbsp;{{ telefoneContato }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </q-page>
    </MainLayout>
</template>

<style scoped>
.titulo-borda {
    border-bottom: 1.5px solid rgb(194, 0, 11);
    padding-bottom: 8px;
}

.lista-bolinha,
.lista-passos {
    margin: 0 0 16px;
    padding-left: 1.25em;
}

.lista-bolinha li,
.lista-passos li {
    margin-bottom: 6px;
}

.lista-bolinha li::marker {
    color: rgb(194, 0, 11);
}

.lista-passos {
    list-style: none;
    padding-left: 0;
    counter-reset: passo;
}

.lista-passos li {
    padding-left: 1.6em;
    position: relative;
}

.lista-passos li::before {
    counter-increment: passo;
    content: counter(passo) ".";
    position: absolute;
    left: 0;
    color: rgb(194, 0, 11);
    font-weight: 700;
}
</style>
